import React from 'react';
import { Box, Button, Typography, CircularProgress } from '@mui/material';
import { useDelayedLoading } from '../hooks/useDelayedLoading';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { PoliceDefaut } from '../helpers/contants';

const DetailNavigation = ({
  currentIndex,
  totalCount,
  onPrevious,
  onNext,
  loading = false,
  hideCounter = false,
  hasNextPage = false,
  hasPreviousPage = false,
}) => {
  const showLoading = useDelayedLoading(loading, 250);
  // Don't render if no navigation context
  if (totalCount <= 0 || currentIndex < 0) {
    return null;
  }

  const isFirst = currentIndex === 0;
  const isLast = currentIndex === totalCount - 1;

  // Show previous button if not first in list OR if there's a previous page
  const canGoPrevious = !isFirst || hasPreviousPage;
  // Show next button if not last in list OR if there's a next page
  const canGoNext = !isLast || hasNextPage;

  const buttonSx = {
    backgroundColor: 'transparent',
    color: '#003D7A',
    fontFamily: PoliceDefaut,
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'none',
    minWidth: 100,
    border: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      opacity: 0.7,
    },
    '&:disabled': {
      color: '#003D7A',
      opacity: 0.2,
    },
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        paddingY: 1.5,
        paddingX: 0,
        backgroundColor: 'white',
        width: '100%',
      }}
    >
      <Button
        onClick={onPrevious}
        disabled={loading || !canGoPrevious}
        startIcon={<ChevronLeft />}
        sx={buttonSx}
      >
        Précédent
      </Button>

      {!hideCounter && (
        <Box
          sx={{
            minWidth: 60,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {showLoading ? (
            <CircularProgress size={20} sx={{ color: '#003D7A' }} />
          ) : (
            <Typography
              variant="body1"
              sx={{
                fontFamily: PoliceDefaut,
                fontWeight: 600,
                fontSize: 14,
                color: '#003D7A',
              }}
            >
              {currentIndex + 1} / {totalCount}
            </Typography>
          )}
        </Box>
      )}

      <Button
        onClick={onNext}
        disabled={loading || !canGoNext}
        endIcon={<ChevronRight />}
        sx={buttonSx}
      >
        Suivant
      </Button>
    </Box>
  );
};

export default DetailNavigation;
